module.exports = __webpack_public_path__ + "img/Forgetful.6ad5c797.png";